import { Box } from '@mantine/core'
import dayjs from 'dayjs'

import Tag from 'src/components/DataDisplay/Tag/Tag'
import { useApplicantDrawerContext } from 'src/context/ApplicantDrawerContext'
import { useCallDrawerContext } from 'src/context/CallDrawerContext'
import { CallDirection } from 'src/graphql/types/activityLogs'
import { buildFullName, formatSnakeValue } from 'src/lib/formatters'

const VoiceAgentAnalysisTable = ({ voiceAgentAnalysisResults }) => {
  const { handleOpen } = useCallDrawerContext()
  const { handleOpen: handleOpenApplicant } = useApplicantDrawerContext()

  return (
    <div className="flex h-[445px] flex-col gap-2 overflow-auto">
      {voiceAgentAnalysisResults.length === 0 ? (
        <div className="flex h-full w-full flex-col items-center justify-center text-sm font-medium text-doubleNickel-gray-500">
          No data available
        </div>
      ) : (
        voiceAgentAnalysisResults.map((result) => (
          <Box
            key={result.activityLogId}
            className="grid grid-cols-7 items-center gap-2 text-nowrap rounded px-2 py-1 text-xs text-gray-500 hover:cursor-pointer hover:bg-doubleNickel-gray-50"
            onClick={() => handleOpen(result.activityLogId)}
          >
            <div className="mx-auto">
              {dayjs(result.activityDate).format('MM/DD/YYYY')}
            </div>
            <div className="mx-auto">
              {dayjs(result.activityDate).format('hh:mm A')}
            </div>
            <Box
              className="mx-auto hover:cursor-pointer hover:text-doubleNickel-brand-500 hover:underline"
              onClick={(e) => {
                e.stopPropagation()
                if (result.applicant) {
                  handleOpenApplicant(result.applicant.applicantId)
                }
              }}
            >
              {result?.applicant
                ? buildFullName(result.applicant)
                : result.callDirection === CallDirection.INBOUND
                ? result.from
                : result.to}
            </Box>
            <div className="mx-auto text-doubleNickel-brand-500">
              {result.voiceAgent.name}
            </div>

            <div className="col-span-3 flex flex-row gap-1 overflow-auto">
              {result.voiceAgentAnalysisResults.map((analysisResult) => (
                <Tag
                  key={analysisResult.name}
                  showCloseButton={false}
                  variant="error"
                  size="xs"
                >
                  {formatSnakeValue(analysisResult.name)}
                </Tag>
              ))}
            </div>
          </Box>
        ))
      )}
    </div>
  )
}

export default VoiceAgentAnalysisTable
